import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const Dashboard = () => {
  const navigate = useNavigate();
  const [currentWeek, setCurrentWeek] = useState(new Date());
  const [workHours, setWorkHours] = useState([]);

  // Données de démonstration
  useEffect(() => {
    const demoData = [
      { day: 'Lundi', start: '09:00', end: '17:00', breaks: ['12:00-13:00'] },
      { day: 'Mardi', start: '08:30', end: '17:30', breaks: ['12:00-12:45'] },
      { day: 'Mercredi', start: '10:00', end: '16:00', breaks: [] },
      { day: 'Jeudi', start: '09:00', end: '18:00', breaks: ['12:30-13:30'] },
      { day: 'Vendredi', start: '08:00', end: '16:00', breaks: ['11:30-12:30'] },
      { day: 'Samedi', start: '', end: '', breaks: [] },
      { day: 'Dimanche', start: '', end: '', breaks: [] },
    ];
    setWorkHours(demoData);
  }, []);

  // Vérification de l'authentification
//   useEffect(() => {
//     const isAuthenticated = localStorage.getItem('isAuthenticated');
//     if (!isAuthenticated) {
//       navigate('/login');
//     }
//   }, [navigate]);

  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Navigation entre les semaines
  const previousWeek = () => {
    setCurrentWeek(new Date(currentWeek.setDate(currentWeek.getDate() - 7)));
  };

  const nextWeek = () => {
    setCurrentWeek(new Date(currentWeek.setDate(currentWeek.getDate() + 7)));
  };

  const formatWeekRange = (date) => {
    const start = new Date(date);
    start.setDate(start.getDate() - start.getDay() + (start.getDay() === 0 ? -6 : 1));
    
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    
    return `${start.toLocaleDateString()} - ${end.toLocaleDateString()}`;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* En-tête */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 gap-4">
          <h1 className="text-2xl font-bold text-gray-900">Mon Planning Hebdomadaire</h1>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center bg-white rounded-md shadow-sm">
              <button 
                onClick={previousWeek}
                className="px-3 py-1 border-r border-gray-200 text-gray-600 hover:bg-gray-50"
              >
                &lt;
              </button>
              <span className="px-4 py-1 text-sm font-medium text-gray-700">
                {formatWeekRange(currentWeek)}
              </span>
              <button 
                onClick={nextWeek}
                className="px-3 py-1 border-l border-gray-200 text-gray-600 hover:bg-gray-50"
              >
                &gt;
              </button>
            </div>
            
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors text-sm"
            >
              Déconnexion
            </button>
          </div>
        </div>

        {/* Planning */}
        <div className="bg-white shadow overflow-hidden rounded-lg">
          <div className="grid grid-cols-1 md:grid-cols-7 gap-px bg-gray-200">
            {workHours.map((day, index) => (
              <div key={index} className="bg-white">
                <div className={`p-3 text-center font-medium ${['Samedi', 'Dimanche'].includes(day.day) ? 'bg-blue-50 text-blue-700' : 'bg-gray-50 text-gray-700'}`}>
                  {day.day}
                </div>
                
                <div className="p-4 h-60">
                  {day.start ? (
                    <div className="space-y-2">
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-500">Début:</span>
                        <span className="font-medium">{day.start}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-sm text-gray-500">Fin:</span>
                        <span className="font-medium">{day.end}</span>
                      </div>
                      
                      {day.breaks.length > 0 && (
                        <div className="mt-2 pt-2 border-t border-gray-100">
                          <span className="text-sm text-gray-500 block mb-1">Pauses:</span>
                          {day.breaks.map((br, i) => (
                            <span key={i} className="block text-sm bg-yellow-50 text-yellow-700 px-2 py-1 rounded">
                              {br}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="flex items-center justify-center h-full text-gray-400">
                      Jour non travaillé
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Résumé */}
        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="font-medium text-gray-700 mb-2">Heures travaillées</h3>
            <p className="text-2xl font-bold">35h</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="font-medium text-gray-700 mb-2">Jours travaillés</h3>
            <p className="text-2xl font-bold">5</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="font-medium text-gray-700 mb-2">Heures supplémentaires</h3>
            <p className="text-2xl font-bold text-green-600">+2h</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;